import Vue from 'vue';
import Router from 'vue-router';
import qs from 'qs';
import { getUnionId } from '@/api/api';
import { isWeiXin, isMobile } from '@/common/ts/common';
import SyActivityDemo from './views/samples';
import SCXFX20220531 from '@/views/20220531SCXFX';
import XLBT20220610 from '@/views/20220610XLBT';
import KHZW20220610 from '@/views/20220610KHZW';
import GKZY20220610 from '@/views/20220610GKZY';
import BXKCQ20220610 from '@/views/20220610BXKCQ';
import AYXS20220610 from '@/views/20220610AYXS';
import WLZJ20211226 from '@/views/20211226WLZJ';
import JGTS20220624 from '@/views/20220624JGTS';
import SYXQ20220707 from '@/views/20220707SYXQ';
import LJPMDS20220714 from '@/views/20220714LJPMDS';
import XXJH20220719 from '@/views/20220719XXJH';
import GZCQ20220722 from '@/views/20220722GZCQ';
import TTZB20220728 from '@/views/20220728TTZB';
import XFTS20220728 from '@/views/20220728XFTS';
import YSPX20220803 from '@/views/20220803YSPX';
import LJGYGG20220810 from '@/views/20220810LJGYGG';
import MYSBJ20220816 from '@/views/20220816MYSBJ';
import CQFC20220819 from '@/views/20220819CQFC';
import LRMQ20220822 from '@/views/20220822LRMQ';
import ZMWG20220824 from '@/views/20220824ZMWG';
import CFJZQ20220826 from '@/views/20220826CFJZQ';
import XSMZQ20220829 from '@/views/20220829XSMZQ';
import WLSB20220907 from '@/views/20220907WLSB';
import TWB20220908 from '@/views/20220908TWB';
import ZXRJ20220919 from '@/views/20220919ZXRJ';
import GYGGTP20220919 from '@/views/20220919GYGGTP';
import ZGGS20220927 from '@/views/20220927ZGGS';
import SYYS20221008 from '@/views/20221008SYYS';
import SG20221015 from '@/views/20221015SG';
import JJ20221015 from '@/views/20221015JJ';
import CQZRQY20221021 from '@/views/20221021CQZRQY';
import SCHB20221024 from '@/views/20221024SCHB';
import JRSY20221104 from '@/views/20221104JRSY';
import YQFK20221110 from '@/views/20221110YQFK';
import guzhen20221111 from '@/views/20221111guzhen';
import yqfk20221115 from '@/views/20221115yqfk';
import hzpd20221116 from '@/views/20221116hzpd';
import JKDR20221121 from '@/views/20221121JKDR';
import YSPX20221125 from '@/views/20221125YSPX';
import WWXD20221129 from '@/views/20221129WWXD';
import PFXT20221202 from '@/views/20221202PFXT';
import drawidea20221208 from '@/views/20221208drawidea';
import danceheath20221213 from '@/views/20221213danceheath';
import guangpan20221223 from '@/views/20221223guangpan';
import YSPXTP20221223 from '@/views/20221223YSPXTP';
import XQD20221223 from '@/views/20221223XQD';
import XNHK20221231 from '@/views/20221231XNHK';
import WQGS20221230 from '@/views/20221230WQGS';
import ninedream20230103 from '@/views/20230103ninedream';
import XJPX20230103 from '@/views/20230103XJPX';
import LH20230107 from '@/views/20230107LH';
import BNWCY20230112 from '@/views/20230112BNWCY';
import CQZM20230202 from '@/views/20230202CQZM';
import ZZYPX20230224 from '@/views/20230224ZZYPX';
import STZT20230228 from '@/views/20230228STZT';
import JJXYWQ20230301 from '@/views/20230301JJXYWQ';
import JJRW20230227 from '@/views/20230227JJRW';
import QGLH20230302 from '@/views/20230302QGLH';
import LJFL20230306 from '@/views/20230306LJFL';
import MZCP20230303 from '@/views/20230303MZCP';
import MZCPTWO20230306 from '@/views/20230306MZCPTWO';
import MZCPTHREE20230308 from '@/views/20230308MZCPTHREE';
import WCSJDS20230310 from '@/views/20230310WCSJDS';
import MZCPFOUR20230315 from '@/views/20230315MZCPFOUR';
import MZCPFIVE20230315 from '@/views/20230315MZCPFIVE';
import MZPCSIX20230324 from '@/views/20230324MZPCSIX';
import WBHCJ20230331 from '@/views/20230331WBHCJ';
import SDKJCX20230404 from '@/views/20230404SDKJCX';
import TYSY20230411 from '@/views/20230411TYSY';
import WLJP20230411 from '@/views/20230411WLJP';
import LJFL120230306LJFL1 from '@/views/20230306LJFL1LJFL1';
import callup20230417 from '@/views/20230417callup';
import REPORT20230426 from '@/views/20230426REPORT';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'HelloWorld',
      component: () => import('@/views/HelloWorld.vue'),
    },
    // Demo展示
    SyActivityDemo,
    // 地标有颜值，城市有温度——双城新发现·第三季
    SCXFX20220531,
    // 强国复兴有我
    XLBT20220610,
    // 第二届重庆青少年科幻作文大赛
    KHZW20220610,
    // 高考志愿
    GKZY20220610,
    // 步行看重庆
    BXKCQ20220610,
    // 爱佑新生 心系妇幼 “1分钟说孕期健康”短视频有奖征集大赛暨“幸福亲子照”有奖征集点赞活动
    AYXS20220610,
    // WL
    WLZJ20211226,
    // 家居投诉专项通道
    JGTS20220624,
    // 上游寻亲公益平台
    SYXQ20220707,
    // 两江新区公益广告平面设大赛
    LJPMDS20220714,
    // 重庆2022优秀竞技后备人才&quot;选星计划&quot;
    XXJH20220719,
    // 感知重庆·渝味传五洲
    GZCQ20220722,
    // 铁塔慢直播
    TTZB20220728,
    // 消费投诉
    XFTS20220728,
    // 2022年度渝商评选
    YSPX20220803,
    // “喜迎党的二十大”两江新区公益广告平面设计大赛
    LJGYGG20220810,
    // 向美而行，以美育人|重庆2022美育双百佳示范案例推选活动
    MYSBJ20220816,
    // 2022重庆福彩“点亮乡村”太阳能路灯
    CQFC20220819,
    // High啤一夏 赢度假好房
    LRMQ20220822,
    // 2022最美网格评选活动
    ZMWG20220824,
    // 财富季专区
    CFJZQ20220826,
    // 新市民专区
    XSMZQ20220829,
    // 首届“武陵山杯”中小学生作文大赛
    WLSB20220907,
    // “跳舞吧，老师”-2022教师节师生共舞短视频大赛与展播
    TWB20220908,
    // 裕农朋友圈”2022首届“写振兴日记·晒农特宝贝
    ZXRJ20220919,
    // 2022年重庆市公益广告大赛
    GYGGTP20220919,
    // 讲好中国故事
    ZGGS20220927,
    // 上游艺术
    SYYS20221008,
    // 二十大时光
    SG20221015,
    // 聚焦二十大
    JJ20221015,
    // 2022年度重庆责任企业巡礼暨年度典型案例征集
    CQZRQY20221021,
    // 2022重庆文博会 最炫武陵风首届山茶花杯创意大赛
    SCHB20221024,
    // 2022重庆金融上游榜
    JRSY20221104,
    // 重庆区县疫情防控信息查询
    YQFK20221110,
    // 第八届重庆古筝比赛
    guzhen20221111,
    // 疫情防控专题
    yqfk20221115,
    // 会展频道栏目改版
    hzpd20221116,
    // 健康运动看我的｜2023重庆渝快保运动健康达人短视频大赛
    JKDR20221121,
    // 2022年度渝商评选
    YSPX20221125,
    // “未”爱守护  共抗疫情
    WWXD20221129,
    // 上游新闻评分系统
    PFXT20221202,
    // 重庆市青少年知识产权绘画海报创意大赛
    drawidea20221208,
    // “舞出健康 无限美好”线上全民健身舞蹈展示大赛
    danceheath20221213,
    // 20221223guanpan
    guangpan20221223,
    // 2022年度十大渝商评选
    YSPXTP20221223,
    // @2023重庆·我的新期待
    XQD20221223,
    // 2023新年体育贺卡
    XNHK20221231,
    // 首届“泉声心·全国温泉歌手大赛”
    WQGS20221230,
    // 重庆市未成年人甜甜虎春节行动
    ninedream20230103,
    // 2022重庆交巡警公安自媒体好新闻评选
    XJPX20230103,
    // 2023两会
    LH20230107,
    // 记者帮你问春运
    BNWCY20230112,
    // 2022发现重庆之美调查推选活动
    CQZM20230202,
    // 第二届重庆市制造业十大影响力年度人物评选
    ZZYPX20230224,
    // 战污染·赞生态
    STZT20230228,
    // 315家居行业维权专题
    JJXYWQ20230301,
    // 2022年度经济人物
    JJRW20230227,
    // 2023全国两会专题
    QGLH20230302,
    // 新时代新征程新重庆 垃圾分类“渝”你同行
    LJFL20230306,
    // 重报集团2022年度领导班子及成员民主测评
    MZCP20230303,
    // 重报集团2022年度领导班子及成员民主测评
    MZCPTWO20230306,
    // 重报集团2022年度领导班子及成员民主测评
    MZCPTHREE20230308,
    // 2023重庆·铜梁文创产品设计大赛
    WCSJDS20230310,
    // 重报集团2022年度领导班子及成员民主测评
    MZCPFOUR20230315,
    // 重报集团2022年度领导班子及成员民主测评
    MZCPFIVE20230315,
    // 重庆国际传播中心民主评测
    MZPCSIX20230324,
    // 文博会抽奖系统
    WBHCJ20230331,
    // 2023十大重庆科技创新年度人物评选
    SDKJCX20230404,
    // 2023渝北区首届体育摄影比赛
    TYSY20230411,
    // “遇见最美重庆”短视频大赛暨2023重庆文旅精品视频巡展
    WLJP20230411,
    // 共建共享美好家园 垃圾分类“渝”你同行
    LJFL120230306LJFL1,
    // callup
    callup20230417,
    // “帮帮”智能问答，帮你玩儿转重庆！
    REPORT20230426,
    {
      path: '*',
      name: 'not-found',
      component: () => import('@/views/NotFound/Home.vue'),
    },
    {
      path: '/code',
      name: 'code',
      component: () => import('@/components/next/MessageLogin.vue'),
    },
    {
      path: '/BindPhone',
      name: 'BindPhone',
      component: () => import('@/components/next/BindPhone.vue'),
    },

  ],
  // 跳转后回到顶部
  scrollBehavior(to, from, savedPosition): any {
    return (
      savedPosition || {
        x: 0,
        y: 0,
      }
    );
  },
});

router.beforeEach(async (to: any, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  // 以下操作均在微信环境中生效
  if (!isWeiXin()) {
    next();
    return;
  }
  const { code } = qs.parse(location.search, {
    ignoreQueryPrefix: true,
  });
  // 控制微信授权是否启用
  if (to.meta.customWeChatAuth) {
    console.log('第三方公众号, 不默认拉取用户信息');
  } else if (code && !localStorage.getItem('unionid')) {
    console.log('request wx user info');
    const res: any = await getUnionId({ code });
    if (res.code === 200) {
      console.log('res.data878738475o3874', res.data);
      window.localStorage.setItem('unionid', res.data.openId);
      window.localStorage.setItem('nickname', res.data.nickname);
      window.localStorage.setItem('headimgurl', res.data.headimgurl);
      // 应将用户微信信息整体存入localStorage
      localStorage.setItem('syWeChatUserInfo', JSON.stringify(res.data));
    } else {
      console.log('清理过期的code');
      // !query中清理过期code字段, 防止用户分享携带有自己的code的页面给其他人，导致无法进行授权登录的状况
      const queries = to.query;
      let strings = '';
      Object.keys(queries).forEach((item: any) => {
        if (item !== 'code') {
          strings += `${item}=${queries[item]}&`;
        }
      });
      strings = strings.slice(0, strings.length - 1);
      location.href = `${window.location.origin}${window.location.pathname}?${strings}`;
    }
  } else {
    console.log('例外');
  }
  next();
});

router.onError((error) => {
  // PC微信解析一个异步组件异常时错误收集
  if (isWeiXin() && !isMobile()) {
    const el = document.createElement('p');
    el.innerHTML = '请复制链接在Chrome, QQ, 360极速/安全等现代浏览器中打开';
    el.style.textAlign = 'center';
    document.body.innerHTML = '';
    document.body.appendChild(el);
  }
  const pattern = /Loading chunk (\d)+ failed/g;
  const isChunkLoadFailed = error.message.match(pattern);
  const targetPath = (router as Router & { history: any }).history.pending
    .fullPath;
  if (isChunkLoadFailed) {
    router.replace(targetPath);
  }
});

export default router;
